export const RUBRIC_AND_SUBRUBRIC_PICKER_CONSTS = {
  rubricAndSubrubricMsg: 'Рубрика, подрубрика',
  selectedMsg: 'Выбрано'
}
